import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LayerColorsService {
  private static luminance(r, g, b) {
    const a = [r, g, b].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
  }

  private static contrast(rgb1, rgb2) {
    return (this.luminance(rgb1.r, rgb1.g, rgb1.b) + 0.05) / (this.luminance(rgb2.r, rgb2.g, rgb2.b) + 0.05);
  }

  private static hexToRgb(hex: string) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result && result.length > 3
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        }
      : null;
  }

  public static getLayerBorderColorFromFillColor(color: string): string {
    const rgb = this.hexToRgb(color);

    if (!rgb) {
      return '#FFFFFF';
    }

    return this.contrast({ r: 255, g: 255, b: 255 }, this.hexToRgb(color)) > 1.5 ? '#FFFFFF' : '#000000';
  }

  public static getLayerFillColor(color: string): string {
    return color || '#03A9F4';
  }
}
